export default __webpack_public_path__ + "static/media/vijaywadaDeitieThree.e8b5c367.png";